__turbopack_context__.v({
  "actions": "PdpHero-module-scss-module__qOiJda__actions",
  "background": "PdpHero-module-scss-module__qOiJda__background",
  "backgroundImage": "PdpHero-module-scss-module__qOiJda__backgroundImage",
  "bottomBar": "PdpHero-module-scss-module__qOiJda__bottomBar",
  "collection": "PdpHero-module-scss-module__qOiJda__collection",
  "container": "PdpHero-module-scss-module__qOiJda__container",
  "content": "PdpHero-module-scss-module__qOiJda__content",
  "hero": "PdpHero-module-scss-module__qOiJda__hero",
  "icon": "PdpHero-module-scss-module__qOiJda__icon",
  "model": "PdpHero-module-scss-module__qOiJda__model",
  "overlay": "PdpHero-module-scss-module__qOiJda__overlay",
  "price": "PdpHero-module-scss-module__qOiJda__price",
  "subtitle": "PdpHero-module-scss-module__qOiJda__subtitle",
  "title": "PdpHero-module-scss-module__qOiJda__title",
  "wishlistButton": "PdpHero-module-scss-module__qOiJda__wishlistButton",
  "wishlistButtonActive": "PdpHero-module-scss-module__qOiJda__wishlistButtonActive",
});
